import { render } from "./PhoneOverrideConfirmationModal.vue?vue&type=template&id=ca84fc64"
import script from "./PhoneOverrideConfirmationModal.vue?vue&type=script&lang=js"
export * from "./PhoneOverrideConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__